const n={path:"/api/v1/funding/coinbase_on_ramp/init",method:"POST"},a={path:"/api/v1/funding/coinbase_on_ramp/status",method:"GET"};export{n as CoinbaseOnRampInit,a as CoinbaseOnRampStatus};
